var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',[_vm._l((_vm.list),function(bind,i){return _c('li',{key:i},[_c('row',_vm._b({},'row',bind,false))],1)}),_vm._t("extended")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }